import React from "react";
import { Box, Typography } from "@material-ui/core";
import {
  CustomBadge,
  CustomButton,
  UnitesProperetyComponentSkeleton,
} from "../../../../../../../../Components";
import { useSelectedTheme, useTranslate } from "../../../../../../../../Hooks";
import { UnitPropertyCard } from "..";
import { Skeleton } from "@material-ui/lab";

// styles
import useStyles from "./styles";

function UnitesComponent({ setTabValue, dataUnit, isloadingUnits }) {
  const styles = useStyles();
  const {
    theme: { palette },
  } = useSelectedTheme();
  const { translate } = useTranslate("NewPropertiesView");

  return (
    <Box className={styles.wapperUnitsComponent}>
      <Box className={styles.containerHeader}>
        {isloadingUnits ? (
          <>
            <Box className={styles.containerLeftHeader}>
              <Skeleton variant="text" width={98} height={45} />
              <Skeleton
                style={{ borderRadius: "16px" }}
                width="39px"
                height="45px"
                variant="text"
              />
            </Box>
            <Skeleton variant="text" width={53} height={45} />
          </>
        ) : (
          <>
            <Box className={styles.containerLeftHeader}>
              <Typography className={styles.containerMainTitle}>
                {translate("Unites")}
              </Typography>
              <CustomBadge
                label={dataUnit?.totalCount}
                SizeVariant={"large"}
                BackgroundColor={palette.utility["brand_50"]}
                BorderColor={palette.utility["brand_200"]}
                Color={palette.utility["brand_700"]}
              />
            </Box>
            {dataUnit.result.length > 0 && (
              <CustomButton
                boxShadow="none"
                size="sm"
                variant="text"
                color="tertiaryGray"
                style={{ minWidth: "fit-content" }}
                onClick={() => {
                  setTabValue(9);
                }}
              >
                {translate("View-All")}
              </CustomButton>
            )}
          </>
        )}
      </Box>
      <Box className={styles.containerCards}>
        {isloadingUnits ? (
          <UnitesProperetyComponentSkeleton numberSkeletonCards={4} />
        ) : dataUnit?.result?.length > 0 ? (
          dataUnit?.result
            .slice(0, 4)
            .map((dataUnitCard, index) => (
              <UnitPropertyCard key={index} dataUnit={dataUnitCard} />
            ))
        ) : (
          <Typography className={styles.containerMainTitle}>
            {translate("No-Data")}
          </Typography>
        )}
      </Box>
    </Box>
  );
}
export default UnitesComponent;
